import RecipesService from 'services/recipes';

const listLatestRecipes = async (lastRecipe) => {
  const lastRecipeID = lastRecipe ? lastRecipe.id : null;
  const recipes = await RecipesService.listLatest(lastRecipeID);
  return recipes;
};

export default listLatestRecipes;
